export const MEGA_POKEMON = [
  { slug: 'venusaur-mega', name: 'Mega-Venusaur', number: 3, accent: '#79e68c' },
  { slug: 'charizard-mega-x', name: 'Mega-Charizard X', number: 6, accent: '#38bdf8' },
  { slug: 'charizard-mega-y', name: 'Mega-Charizard Y', number: 6, accent: '#ffb74d' },
  { slug: 'blastoise-mega', name: 'Mega-Blastoise', number: 9, accent: '#60a5fa' },
  { slug: 'beedrill-mega', name: 'Mega-Beedrill', number: 15, accent: '#facc15' },
  { slug: 'pidgeot-mega', name: 'Mega-Pidgeot', number: 18, accent: '#bae6fd' },
  { slug: 'alakazam-mega', name: 'Mega-Alakazam', number: 65, accent: '#f5a3ff' },
  { slug: 'slowbro-mega', name: 'Mega-Slowbro', number: 80, accent: '#fb8bd6' },
  { slug: 'gengar-mega', name: 'Mega-Gengar', number: 94, accent: '#c084fc' },
  { slug: 'kangaskhan-mega', name: 'Mega-Kangaskhan', number: 115, accent: '#d6b28b' },
  { slug: 'pinsir-mega', name: 'Mega-Pinsir', number: 127, accent: '#b5e8ff' },
  { slug: 'gyarados-mega', name: 'Mega-Gyarados', number: 130, accent: '#22d3ee' },
  { slug: 'aerodactyl-mega', name: 'Mega-Aerodactyl', number: 142, accent: '#a78bfa' },
  { slug: 'mewtwo-mega-x', name: 'Mega-Mewtwo X', number: 150, accent: '#d8b4fe' },
  { slug: 'mewtwo-mega-y', name: 'Mega-Mewtwo Y', number: 150, accent: '#f0abfc' },
  { slug: 'ampharos-mega', name: 'Mega-Ampharos', number: 181, accent: '#fde047' },
  { slug: 'steelix-mega', name: 'Mega-Steelix', number: 208, accent: '#94a3b8' },
  { slug: 'scizor-mega', name: 'Mega-Scizor', number: 212, accent: '#fb4f55' },
  { slug: 'heracross-mega', name: 'Mega-Heracross', number: 214, accent: '#818cf8' },
  { slug: 'houndoom-mega', name: 'Mega-Houndoom', number: 229, accent: '#f97316' },
  { slug: 'tyranitar-mega', name: 'Mega-Tyranitar', number: 248, accent: '#a3e635' },
  { slug: 'sceptile-mega', name: 'Mega-Sceptile', number: 254, accent: '#22c55e' },
  { slug: 'blaziken-mega', name: 'Mega-Blaziken', number: 257, accent: '#fb3f3f' },
  { slug: 'swampert-mega', name: 'Mega-Swampert', number: 260, accent: '#60a5fa' },
  { slug: 'gardevoir-mega', name: 'Mega-Gardevoir', number: 282, accent: '#f9a8d4' },
  { slug: 'sableye-mega', name: 'Mega-Sableye', number: 302, accent: '#d946ef' },
  { slug: 'mawile-mega', name: 'Mega-Mawile', number: 303, accent: '#f0abfc' },
  { slug: 'aggron-mega', name: 'Mega-Aggron', number: 306, accent: '#cbd5e1' },
  { slug: 'medicham-mega', name: 'Mega-Medicham', number: 308, accent: '#fb7185' },
  { slug: 'manectric-mega', name: 'Mega-Manectric', number: 310, accent: '#facc15' },
  { slug: 'sharpedo-mega', name: 'Mega-Sharpedo', number: 319, accent: '#38bdf8' },
  { slug: 'camerupt-mega', name: 'Mega-Camerupt', number: 323, accent: '#ef4444' },
  { slug: 'altaria-mega', name: 'Mega-Altaria', number: 334, accent: '#bfdbfe' },
  { slug: 'banette-mega', name: 'Mega-Banette', number: 354, accent: '#a78bfa' },
  { slug: 'absol-mega', name: 'Mega-Absol', number: 359, accent: '#e2e8f0' },
  { slug: 'glalie-mega', name: 'Mega-Glalie', number: 362, accent: '#bae6fd' },
  { slug: 'salamence-mega', name: 'Mega-Salamence', number: 373, accent: '#818cf8' },
  { slug: 'metagross-mega', name: 'Mega-Metagross', number: 376, accent: '#60a5fa' },
  { slug: 'latias-mega', name: 'Mega-Latias', number: 380, accent: '#f472b6' },
  { slug: 'latios-mega', name: 'Mega-Latios', number: 381, accent: '#38bdf8' },
  { slug: 'rayquaza-mega', name: 'Mega-Rayquaza', number: 384, accent: '#4ade80' },
  { slug: 'lopunny-mega', name: 'Mega-Lopunny', number: 428, accent: '#fda4af' },
  { slug: 'garchomp-mega', name: 'Mega-Garchomp', number: 445, accent: '#818cf8' },
  { slug: 'lucario-mega', name: 'Mega-Lucario', number: 448, accent: '#2dd4bf' },
  { slug: 'abomasnow-mega', name: 'Mega-Abomasnow', number: 460, accent: '#a7f3d0' },
  { slug: 'gallade-mega', name: 'Mega-Gallade', number: 475, accent: '#5eead4' },
  { slug: 'audino-mega', name: 'Mega-Audino', number: 531, accent: '#f9a8d4' },
  { slug: 'diancie-mega', name: 'Mega-Diancie', number: 719, accent: '#fb7185' },
];

export const FEATURED_SLUGS = ['charizard-mega-x', 'lucario-mega', 'gardevoir-mega'];

export const DESCRIPTIONS = {
  'charizard-mega-x': 'La megaenergía oscurece su cuerpo y convierte sus llamas en un azul intenso. Su nueva fuerza favorece el combate directo.',
  'charizard-mega-y': 'Sus alas se expanden y su poder de fuego alcanza una temperatura extraordinaria al surcar los cielos.',
  'lucario-mega': 'La energía de la megaevolución amplifica su aura y agudiza cada uno de sus instintos de combate.',
  'gardevoir-mega': 'Libera toda su energía psíquica, abre el corazón de su pecho y protege a su Entrenador con absoluta determinación.',
  'venusaur-mega': 'La enorme flor de su lomo absorbe todavía más luz solar y sostiene su cuerpo con una fuerza renovada.',
  'blastoise-mega': 'El gran cañón de su caparazón concentra potentes chorros de agua con una precisión excepcional.',
  'rayquaza-mega': 'La energía de los meteoritos despierta una forma legendaria capaz de dominar los cielos.',
  'mewtwo-mega-x': 'Su cuerpo desarrolla una extraordinaria potencia física sin perder su formidable capacidad psíquica.',
  'mewtwo-mega-y': 'Una forma más ligera y compacta que concentra un poder psíquico difícil de medir.',
};

export const TYPE_LABELS = {
  normal: 'Normal',
  fire: 'Fuego',
  water: 'Agua',
  electric: 'Eléctrico',
  grass: 'Planta',
  ice: 'Hielo',
  fighting: 'Lucha',
  poison: 'Veneno',
  ground: 'Tierra',
  flying: 'Volador',
  psychic: 'Psíquico',
  bug: 'Bicho',
  rock: 'Roca',
  ghost: 'Fantasma',
  dragon: 'Dragón',
  dark: 'Siniestro',
  steel: 'Acero',
  fairy: 'Hada',
};

export const STAT_LABELS = {
  hp: 'PS',
  attack: 'Ataque',
  defense: 'Defensa',
  'special-attack': 'At. Esp.',
  'special-defense': 'Def. Esp.',
  speed: 'Velocidad',
};
